"use strict";

var IntegrationTitle = require("app/screens/Integration/shared/components/integration-title");

var GoogleCalendarTitle = React.createClass({
  mixins: [ReactIntl.IntlMixin],

  render: function() {
    var title = this.getIntlMessage("integration.google_calendar.title");
    return <IntegrationTitle title={title} />;
  }
});

module.exports = GoogleCalendarTitle;



// WEBPACK FOOTER //
// ./app/screens/Integration/components/GoogleCalendar/google-calendar-title.jsx